import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import {StaticQuery, graphql} from 'gatsby'
import moment from 'moment'
import urlJoin from 'url-join'

import place from './images/place.svg'

import {QueriedGatsbyImage} from '../GatsbyImage'
import SmartLink from '../SmartLink'

const RootContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	margin: -2rem -.5rem;
	> * {
		padding: 0 1rem;
		margin: 2rem 0;
	}
`

const OneItem = styled.div`
	width: 33.333%;
	
	
	@media only screen and (max-width: 1000px) {
		width: 50%;
	}	
	
	@media only screen and (max-width: 700px) {
		width: 100%;
	}	
	
	
`

const InnerItem = styled(SmartLink)`
	display: block;
	background: #F6F6F6;
	padding: 2.5rem 2rem;
	width: 100%;
	height: 100%;
	position: relative;
	font-size: ${props => props.theme.fontSizes.small};
	font-weight: ${props => props.theme.fontWeights.regular};
	
	&:hover {
		text-decoration: none;
	}
`

const Instructors = styled.div`
	margin: 0 0.25rem;
	position: absolute;
	top: -1.2rem;
	left: 2rem;
	
`

const InstructorPhoto = styled(QueriedGatsbyImage)`
	border-radius: 20px;
	margin: 0 -.25rem;
`

const Date = styled.div`
	color: ${props => props.theme.colors.grayText};
`

const Name = styled.div`
	font-size: ${props => props.theme.fontSizes.big30};
	font-weight: ${props => props.theme.fontWeights.bold};
	margin: 1.3rem 0 2.1rem;
`

const Description = styled.div`
	margin-bottom: 2rem;
`

const Place = styled.div`
	display: flex;
	align-items: center;
	margin-bottom: 1.3rem;
	color: ${props => props.theme.colors.grayText}

`
const Pin = styled.img`
	margin-right: .75rem;
	margin-bottom: 0
`

Pin.defaultProps = {
	src: place,
	alt: '',
}

const Price = styled.div`
	font-size: ${props => props.theme.fontSizes.big30};
	font-weight: ${props => props.theme.fontWeights.bold};
`

const PriceCurrency = styled.span`
	margin-left: .5rem;
	font-weight: ${props => props.theme.fontWeights.regular};
	font-size: ${props => props.theme.fontSizes.small};
`

function CoursesList({className, excludeSlug, maxCount}) {
	return <StaticQuery
		query={graphql`
			{
			coursesList: file(relativePath: {eq: "pages/coursesListPage.json"}) {
				childPagesJson {
				  url
				}
			  }
			  allCoursesJsonWithRelativePaths(sort: {fields: date, order: DESC}, filter: {show: {ne: false}}) {
				nodes {
				  date
				  title
				  place
				  price
				  priceCurrency
				  shortDescription
				  slug
				  instructors {
				  	instructor
				  }
				}
			  }

			  allAuthorsJsonWithRelativePaths {
				nodes {
					name
					photo {
					  childImageSharp {
						fixed(width: 40, height: 40, cropFocus: NORTH) {
							...GatsbyImageSharpFixed
						}
					  }
					}
				}
			  }
			}

		`}
		render={(rawData) => {

			const {
				allCoursesJsonWithRelativePaths: rawCourses,
				allAuthorsJsonWithRelativePaths: rawAuthors,
				coursesList: {childPagesJson: {url}},
			} = rawData
			const courses = !!maxCount
				? rawCourses.nodes.filter(one => one.slug !== excludeSlug).slice(0, maxCount)
				: rawCourses.nodes.filter(one => one.slug !== excludeSlug)
			const authors = rawAuthors.nodes

			return <RootContainer className={className}>
				{courses
					.map(one => <OneItem key={one.slug}>
						<InnerItem to={urlJoin(url, one.slug)}>
							<Instructors>
								{one.instructors
									.map(({instructor}) => authors.find(author => author.name === instructor))
									.filter(Boolean)
									.map(instructor => <InstructorPhoto image={instructor.photo}/>)}
							</Instructors>
							<Date>{moment(one.date).format('MMMM D, YYYY')}</Date>
							<Name> {one.title}</Name>
							<Description>{one.shortDescription}</Description>
							<Place><Pin/> {one.place}</Place>
							<Price>
								{one.price}
								<PriceCurrency>{one.priceCurrency}</PriceCurrency>
							</Price>
						</InnerItem>
					</OneItem>)}
			</RootContainer>
		}
		}/>
}

CoursesList.propTypes = {
	className: PropTypes.string,
	excludeSlug: PropTypes.string,
	maxCount: PropTypes.number,
}

CoursesList.defaultProps = {
	className: '',
	excludeSlug: null,
	maxCount: 0,
}

export default CoursesList
